module.exports = __webpack_public_path__ + "media/images/application/template/icon--map-marker_smaller-1a8af9883053ed886615ca412672da21.svg";